import { render, staticRenderFns } from "./AppWrapper.vue?vue&type=template&id=dc352bc2&"
import script from "./AppWrapper.js?vue&type=script&lang=js&"
export * from "./AppWrapper.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports